import type { XGeometryHeader } from '@library/types'

import { isDomainType } from '../types'
import { hasKeysOfUnknown, isNumber, isObject } from './common'

export const isXGeometryHeader = (value: unknown): value is XGeometryHeader =>
  isObject(value) &&
  hasKeysOfUnknown(
    value,
    'id',
    'name',
    'domainType',
    'minX',
    'maxX',
    'minY',
    'maxY',
    'minZ',
    'maxZ',
    'avgZ',
    'rows',
    'columns',
    'offsetX',
    'offsetY',
    'stepX',
    'stepY',
    'rotationX',
    'rotationY',
    'rotationAngle',
    'nullValue',
  ) &&
  isDomainType(value.domainType) &&
  isNumber(value.minX) &&
  isNumber(value.maxX) &&
  isNumber(value.minY) &&
  isNumber(value.maxY) &&
  isNumber(value.minZ) &&
  isNumber(value.maxZ) &&
  isNumber(value.avgZ) &&
  isNumber(value.rows) &&
  isNumber(value.columns) &&
  isNumber(value.offsetX) &&
  isNumber(value.offsetY) &&
  isNumber(value.stepX) &&
  isNumber(value.stepY) &&
  isNumber(value.rotationX) &&
  isNumber(value.rotationY) &&
  isNumber(value.rotationAngle) &&
  isNumber(value.nullValue)
